module.exports = __webpack_public_path__ + "static/media/parts_23.ae07b9ca.svg";